"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const DragIndicatorRounded_1 = __importDefault(require("@mui/icons-material/DragIndicatorRounded"));
const clsx_1 = __importDefault(require("clsx"));
const Tooltip_1 = __importDefault(require("../Tooltip/Tooltip"));
const ButtonDrag = ({ canReorder, dragHandle, className, }) => (react_1.default.createElement(Tooltip_1.default, { content: "Reorder", delay: 0 },
    react_1.default.createElement("div", { tabIndex: 0, role: "button", "aria-disabled": !canReorder, ...dragHandle.dragHandleProps, className: (0, clsx_1.default)('btn-drag-handle btn btn-icon btn-default-transparent', { disabled: !canReorder }, className) },
        !canReorder ? (react_1.default.createElement(DragIndicatorRounded_1.default, { className: "icon icon-subtle" })) : (react_1.default.createElement(DragIndicatorRounded_1.default, { className: "icon icon-subtle" })),
        react_1.default.createElement("span", { className: "sr-only" }, "Reorder"))));
exports.default = ButtonDrag;
